




















































import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component, Prop } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { actionsEvent } from '@/setup';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import Confirmation from '@/components/Confirmation.vue';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchSolicitud } from '../fetchSolicitud';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import TodasSims from './TodasSims.vue';
@Component({
  components: {
    MantenedorGridSinCodigo,
    TodasSims,
  },
})
export default class Sims extends ComponenteBase {
  verTodasSims: boolean = false;
  filtro: string = '';
  ordesList: any[] = [];
  funcionalidad: Funcionalidades = Funcionalidades.TablaSolicitudBajaSimTarjeta;
  modalTodasSims: any;

  async postSims(): Promise<boolean> {
    let self = this;
    return fetchSolicitud(
      {
        sims: this.datosSims,
      },
      'solicitud_baja_sim_por_tarjeta/crear_sims'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success('Solicitud creada con exito', {
            timeout: 3000,
          });
          return true;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return false;
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrio un error al crear la solicitud', {
          timeout: 3000,
        });
        return false;
      });
  }

  datosSims: any;
  async guardarSims(data: any) {
    let generalNumero = data;
    this.datosSims = this.dataSelected.map((sim: any) => ({
      sbajasimnumero: generalNumero,
      simserienumero: sim.simserienumero,
      tipoubicaid: sim.tipoubicaid,
      simestado: sim.simestado,
      serienumero: sim.serienumero,
      tipoeqid: sim.tipoeqid,
      serieactivanro: sim.serieactivanro,
    }));
    let post = await this.postSims();
    return post;
  }

  mounted() {
    this.modalTodasSims = this.$refs.TodasSims;
  }

  /* returnUnicos(data: any) {
    let hash: any = {};
    let unicos = data.filter((seleccion: any) =>
      hash[seleccion.simserienumero]
        ? false
        : (hash[seleccion.simserienumero] = true)
    );
    return unicos;
  } */

  dataSelected: any = [];
  idsSims: any = [];
  cargarSelected(data: any) {
    this.dataSelected.push(...data);
    this.gridApi.setRowData(this.dataSelected);
    this.$emit('selected', this.dataSelected);
    this.gridApi.setDomLayout('autoHeight');
    this.idsSims = this.dataSelected.map((e: any) => {
      return e.simserienumero;
    });
  }

  cargarSimTodas() {
    this.verTodasSims = true;
    this.modalTodasSims.clearFilters();
  }

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }
  onSelectionChanged() {}
  accionesTotales: PermisoAccion[] = [];

  // Globales
  localeText: any = config.agGridTextos;
  loadingService = new LoadingService();
  handleErrors: HandleErrors = new HandleErrors();

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  agGridUtil: AgGridUtil;
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  dateFormatter(params: any) {
    return moment(params.value).format('MM/DD/YYYY');
  }
  constructor() {
    super();
  }

  readonly gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 30,
    rowModelType: 'normal',
    singleClickEdit: true,
    localeText: {
      noRowsToShow: 'No se han seleccionado sim cards',
    },
    columnDefs: [
      {
        headerName: 'SIM Número',
        field: 'simserienumero',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        minWidth: 200,
        width: 200,
        lockPinned: true,
      },
      {
        headerName: 'Serie Equipo',
        field: 'serienumero',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Tipo Equipo',
        field: 'tipoeqname',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Ubicación',
        field: 'tipoubicaname',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Telco',
        field: 'telconame',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        minWidth: 200,
        width: 200,
        lockPinned: true,
      },
      {
        headerName: 'Plan',
        field: 'telcoplanname',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        width: 300,
        minWidth: 300,
      },
      {
        headerName: 'Móvil',
        field: 'simmovil',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        minWidth: 200,
        width: 200,
        lockPinned: true,
      },
      {
        headerName: 'Estado',
        field: 'configvalor',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
    ],
    //rowModelType: 'serverSide',
    serverSideDatasource: this.serverSide,
    rowSelection: 'multiple',
    columnTypes: {
      fecha: {
        sortable: true,
        resizable: true,
        filter: false,
      },
    },
    onGridReady: this.handleGridReady,
    onModelUpdated: this.onModelUpdated,
    onSelectionChanged: this.onSelectionChanged,
    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
    onGridSizeChanged: event => {
      event.api.sizeColumnsToFit();
    },
  };

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  created() {
    this.initialize();
  }

  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (this.funcionalidad === Funcionalidades.TablaSolicitudBajaSimTarjeta) {
        if (data.action === Accion.Eliminar) {
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            let indexDelete = this.dataSelected.indexOf(
              data.cellRendererParams.data
            );
            this.dataSelected.splice(indexDelete, 1);
            this.gridApi.setRowData(this.dataSelected);
            this.gridApi.setDomLayout('autoHeight');
            this.$emit('selected', this.dataSelected);
            this.idsSims = this.dataSelected.map((e: any) => {
              return e.simserienumero;
            });
          }
        }
      }
    });
  }
}
